import type { SidebarMenuItem } from '../ui/MenuItem';

// Активен ли пункт меню на этом пути: сам пункт, любой его подпункт или путь
// экрана, живущего табом внутри раздела (activePaths). Для видов навигации, где
// группа — одна кнопка (рейка планшета) или раскрывающийся список (меню на весь
// экран). Корень «/» совпадает только сам с собой, иначе он активен всегда.
export const isMenuItemActive = (item: SidebarMenuItem, pathname: string): boolean => {
  const matches = (path: string) => (path === '/' ? pathname === '/' : pathname.startsWith(path));

  return (
    matches(item.link) ||
    item.sublinks.some((sub) => matches(sub.link)) ||
    Boolean(item.activePaths?.some(matches))
  );
};
